module.exports = __webpack_public_path__ + "src/assets/sanya_2017/7.jpg";